import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActiveModal } from '@rocketfinancialcorp/rocket-ui/modal';
import { RktButtonDirective } from '@rocketfinancialcorp/rocket-ui/button';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';

@Component({
  selector: 'app-add-service-account-success',
  templateUrl: 'add-service-account-success.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, RktButtonDirective, RktIconComponent],
})
export class AddServiceAccountSuccessComponent {
  activeModal = inject(ActiveModal);

  copyFlag = false;

  apiKeyId!: string;

  apiKeySecret!: string;

  isReset = false;

  modalInitData({ apiKeyId, apiKeySecret, isReset }: { apiKeyId: string; apiKeySecret: string; isReset: boolean }) {
    this.apiKeyId = apiKeyId;
    this.apiKeySecret = apiKeySecret;
    this.isReset = isReset;
  }

  copyToClipboard() {
    if (!this.copyFlag) {
      this.copyFlag = true;
      const text = (document.querySelector('#api-keys') as HTMLDivElement)?.innerText;
      const textArea = document.createElement('textarea')!;
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      navigator.clipboard.writeText(textArea.value);
      document.body.removeChild(textArea);
      setTimeout(() => {
        this.copyFlag = false;
      }, 1000);
    }
  }
}
